import { useState, useContext } from 'react';
import _noop from 'lodash/noop';
import dayjs from 'dayjs';
import _get from 'lodash/get';

import { ModalContext, AppContext } from 'commons-ui';
import { KycCrmDashboardRequest } from 'commons/models/kyc.model';

import useService from '../../useService';
import { KycFormData } from './types';
import { IUseContentProps } from '../types';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from './formConfig';

const useContent = (props: IUseContentProps) => {
	const { handleForceUpdate = _noop } = props;
	const { getKycDocsOptions, getKycSignedUrl, putKycDocToSignedUrl, submitKyc } = useService();

	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DOCUMENT_TYPE].setRenderProps({ getOptions: getKycDocsOptions });

	const handleFormSubmit = async (submittedData: KycFormData) => {
		const { frontImage, dob, deviceType, documentNumber, documentType, fullName } = submittedData;
		try {
			setShowLoader(true);
			const result = await getKycSignedUrl();
			const signedUrl = _get(result, ['data', 'data', 'data', 'signedUrl']);
			const fileName = _get(result, ['data', 'data', 'data', 'filename']);
			await putKycDocToSignedUrl(signedUrl, frontImage);

			const formattedData: KycCrmDashboardRequest = {
				deviceType,
				documentNumber,
				documentType,
				fullName,
				frontImageName: fileName,
				dob: dayjs(dob).format('DD/MM/YYYY')
			};
			await submitKyc(formattedData);
			setShowLoader(false);
			showAlert('Kyc docs submitted successfully. Please check the status after some time');
		} catch (error) {
			showAlert(_get(error, ['response', 'data', 'error'], 'Error in submitting kyc'), { type: 'error' });
		} finally {
			setShowLoader(false);
			handleForceUpdate();
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
